export default __webpack_public_path__ + "static/illustration-ownership-8d1d4f5843d85ed9de9f00da9dcb2263.svg";